module.exports = __webpack_public_path__ + "static/img/biggest_rewards.8645f9ee.png";